import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { isLocal } from "./detectEnv";

export let awsRum: AwsRum;

export async function initAwsRum(alias: string) {
  try {
    if (isLocal()) return;

    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: "https://dataplane.rum.ap-southeast-2.amazonaws.com",
      identityPoolId: "ap-southeast-2:d7e5f005-84bd-4b7e-95bf-a22fff556cca",
      telemetries: ["errors", "performance", "http"],
      allowCookies: true,
      enableXRay: false,
    };

    const APPLICATION_ID = "f4217def-dd15-459a-95a7-04ba1bcb79cc";
    const APPLICATION_VERSION = "1.0.0";
    const APPLICATION_REGION = "ap-southeast-2";

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );

    awsRum.addSessionAttributes({ alias: alias });
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.log("RUM client initialize fail with error: ", error);
  }
}

export const sendCustomRUMEvent = (eventName: string, eventData: object) => {
  if (isLocal()) return;
  awsRum.recordEvent(eventName, eventData);
};
